import { useReducer } from 'react';

var updateReducer = function updateReducer(num) {
  return (num + 1) % 1000000;
};

var useUpdate = function useUpdate() {
  var _a = useReducer(updateReducer, 0),
      update = _a[1];

  return update;
};

export default useUpdate;